import { Spin } from '@douyinfe/semi-ui'
import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { AppLayout } from '@/components/AppLayout'
import { LoginPage } from '@/pages/LoginPage'
import { NotFoundPage } from '@/pages/NotFoundPage'

const DashboardPage = lazy(() =>
  import('@/pages/DashboardPage').then(m => ({ default: m.DashboardPage })),
)
const ProjectOverviewPage = lazy(() =>
  import('@/pages/ProjectOverviewPage').then(m => ({
    default: m.ProjectOverviewPage,
  })),
)
const CDKeyListPage = lazy(() =>
  import('@/pages/CDKeyListPage').then(m => ({ default: m.CDKeyListPage })),
)
const CDKeyBatchPage = lazy(() =>
  import('@/pages/CDKeyBatchPage').then(m => ({ default: m.CDKeyBatchPage })),
)
const DeviceManagementPage = lazy(() =>
  import('@/pages/DeviceManagementPage').then(m => ({
    default: m.DeviceManagementPage,
  })),
)
const VersionManagementPage = lazy(() =>
  import('@/pages/VersionManagementPage').then(m => ({
    default: m.VersionManagementPage,
  })),
)
const TemplateListPage = lazy(() =>
  import('@/pages/TemplateListPage').then(m => ({
    default: m.TemplateListPage,
  })),
)
const OrderManagementPage = lazy(() =>
  import('@/pages/OrderManagementPage').then(m => ({
    default: m.OrderManagementPage,
  })),
)
const UserManagementPage = lazy(() =>
  import('@/pages/UserManagementPage').then(m => ({
    default: m.UserManagementPage,
  })),
)
const SettingsPage = lazy(() =>
  import('@/pages/SettingsPage').then(m => ({
    default: m.SettingsPage,
  })),
)
const WechatUserPage = lazy(() =>
  import('@/pages/WechatUserPage').then(m => ({
    default: m.WechatUserPage,
  })),
)

function PageLoader() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <Spin size="large" />
    </div>
  )
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<AppLayout />}>
        <Route
          index
          element={(
            <Suspense fallback={<PageLoader />}>
              <DashboardPage />
            </Suspense>
          )}
        />
        <Route
          path="projects/:project"
          element={(
            <Suspense fallback={<PageLoader />}>
              <ProjectOverviewPage />
            </Suspense>
          )}
        />
        <Route
          path="projects/:project/cdkeys"
          element={(
            <Suspense fallback={<PageLoader />}>
              <CDKeyListPage />
            </Suspense>
          )}
        />
        <Route
          path="projects/:project/batches"
          element={(
            <Suspense fallback={<PageLoader />}>
              <CDKeyBatchPage />
            </Suspense>
          )}
        />
        <Route
          path="projects/:project/devices"
          element={(
            <Suspense fallback={<PageLoader />}>
              <DeviceManagementPage />
            </Suspense>
          )}
        />
        <Route
          path="projects/:project/versions"
          element={(
            <Suspense fallback={<PageLoader />}>
              <VersionManagementPage />
            </Suspense>
          )}
        />
        <Route
          path="projects/:project/orders"
          element={(
            <Suspense fallback={<PageLoader />}>
              <OrderManagementPage />
            </Suspense>
          )}
        />
        <Route
          path="templates"
          element={(
            <Suspense fallback={<PageLoader />}>
              <TemplateListPage />
            </Suspense>
          )}
        />
        <Route
          path="users"
          element={(
            <Suspense fallback={<PageLoader />}>
              <UserManagementPage />
            </Suspense>
          )}
        />
        <Route
          path="settings"
          element={(
            <Suspense fallback={<PageLoader />}>
              <SettingsPage />
            </Suspense>
          )}
        />
        <Route
          path="wechat"
          element={(
            <Suspense fallback={<PageLoader />}>
              <WechatUserPage />
            </Suspense>
          )}
        />
        <Route path="404" element={<NotFoundPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  )
}
